import Modal from "./Modal";

// 当クラスはモーダルの開きと閉じの処理を担当する
// 「Modal」のクラスを利用しています。
class Catalouge extends Modal {
    constructor({modalId, modalCloser, modalOpener, isFilter}, downloadBtn) {
        // 「Modal」クラスの以下の引数を上書する
        super({modalId, modalCloser, modalOpener, isFilter});

        this.downloadBtn = document.querySelector(`.${downloadBtn}`);
        this.isDownloading = document.getElementById('isDownloading');

        if(this.modalOpeners && this.modal && this.downloadBtn) {
            this.catalougeEvent();
        }

    }

    // ============
    // Events
    // =============
    catalougeEvent() {
        this.downloadBtn.addEventListener('click', () => {
            this.isDownloading.innerHTML = "ダウンロード中．．．";
            this.downloadBtn.classList.add('deactivated');
            setTimeout(() => {
                this.handleModalClose();
                this.downloadBtn.classList.remove('deactivated');
                this.isDownloading.innerHTML = "";
            }, 400 );
        });
    }
}

export default Catalouge;